import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // ✅ Must have this
import StoreOwner from './components/StoreOwner';
import CustomerView from './components/CustomerView';
import './App.css';  // ✅ Must have this

function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          <Route path="/" element={<StoreOwner />} />
          <Route path="/pay/:paymentLinkId" element={<CustomerView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;